import { Post, Get, Put, Delete } from "@/utils";
import { ApiPath, UserRoles } from "@/enums";

export default {
  namespaced: true,
  state: {
    hiddenTasks: undefined,
    jobDescriptions: [],
    jobDescriptionTasks: undefined,
    jobRole: undefined,
    relatedWorkExperience: undefined,
    relatedTraining: undefined,
    relatedEducation: undefined,
    additionalKnowledge: undefined,
    workActivities: undefined,
    mindsets: undefined,
    workSkills: undefined,
    workStyles: undefined,
    softSkills: [],
    hiddenTalents: [],
    current_sga: {
      isComplete: false,
      sgaEmployeeInfo: {
        confirmEmailAddress: "",
        employeeDepartment: "",
        employeeLineManager: "",
        employeeStartEmploymentDate: undefined,
        employeeRoleOnetCode: "",
        employeeRoleTitle: "",
        employeeRoleTitleLevel: "",
      },
    },
    certificates: [],
  },
  mutations: {
    SET_SGA(state, payload) {
      state.current_sga = Object.assign(state.current_sga, payload);
    },
    SET_JOB_DESCRIPTIONS(state, descriptions) {
      state.jobDescriptions = descriptions;
    },
    SET_HIDDEN_TASKS(state, hiddenTasks) {
      state.hiddenTasks = hiddenTasks;
    },
    SET_JOB_TASKS(state, jobTasks) {
      state.jobDescriptionTasks = jobTasks;
    },
    SET_JOB_TITLE_AND_DESCRIPTION(state, jobRole) {
      state.jobRole = jobRole;
    },
    SET_WORK_EXPERIENCE(state, relatedWorkExperience) {
      state.relatedWorkExperience = relatedWorkExperience;
    },
    SET_WORK_TRAINING(state, relatedTraining) {
      state.relatedTraining = relatedTraining;
    },
    SET_WORK_EDUCATION(state, relatedEducation) {
      state.relatedEducation = relatedEducation;
    },
    SET_ADDITIONAL_KNOWLEDGE(state, additionalKnowledge) {
      state.additionalKnowledge = additionalKnowledge;
    },
    SET_WORK_ACTIVITIES(state, workActivities) {
      state.workActivities = workActivities;
    },
    SET_MINDSETS(state, mindsets) {
      state.mindsets = mindsets;
    },
    SET_WORK_SKILLS(state, workSkills) {
      state.workSkills = workSkills;
    },
    SET_WORK_STYLES(state, workStyles) {
      state.workStyles = workStyles;
    },
    SET_SOFT_STYLES(state, softSkills) {
      state.softSkills = softSkills;
    },
    SET_HIDDEN_TALENTS(state, hiddenTalents) {
      state.hiddenTalents = hiddenTalents;
    },
    SET_CERTIFICATES(state, certificates) {
      state.certificates = certificates;
    },
  },
  actions: {
    setHiddenTalents({ commit }, hiddenTalents) {
      commit("SET_HIDDEN_TALENTS", hiddenTalents);
    },
    setHiddenTasks({ commit }, hiddenTasks) {
      commit("SET_HIDDEN_TASKS", hiddenTasks);
    },
    setJobDescriptions({ commit }, descriptions) {
      commit("SET_JOB_DESCRIPTIONS", descriptions);
    },
    setJobTasks({ commit }, jobTasks) {
      commit("SET_JOB_TASKS", jobTasks);
    },
    setJobTitleAndDescription({ commit }, jobTitleAndDescription) {
      commit("SET_JOB_TITLE_AND_DESCRIPTION", jobTitleAndDescription);
    },
    setWorkExperience({ commit }, workExperience) {
      commit("SET_WORK_EXPERIENCE", workExperience);
    },
    setWorkTraining({ commit }, workTraining) {
      commit("SET_WORK_TRAINING", workTraining);
    },
    setWorkEducation({ commit }, workEducation) {
      commit("SET_WORK_EDUCATION", workEducation);
    },
    setAdditionalKnowledge({ commit }, additionalKnowledge) {
      commit("SET_ADDITIONAL_KNOWLEDGE", additionalKnowledge);
    },
    setWorkActivities({ commit }, workActivities) {
      commit("SET_WORK_ACTIVITIES", workActivities);
    },
    setMindsets({ commit }, mindsets) {
      commit("SET_MINDSETS", mindsets);
    },
    setWorkSkills({ commit }, workSkills) {
      commit("SET_WORK_SKILLS", workSkills);
    },
    setWorkStyles({ commit }, workStyles) {
      commit("SET_WORK_STYLES", workStyles);
    },
    setSoftSkills({ commit }, softSkills) {
      commit("SET_SOFT_STYLES", softSkills);
    },
    
    async getsga({ commit }) {
      const isApprentice =
        this.state.account.current_user.roles.includes("Apprentice");
      if (isApprentice) {
        const { data: apprenticeSga } = await Get(
          `${ApiPath.ApprenticeSurvey}/getapprenticesga`
        );
        commit("SET_SGA", apprenticeSga);
        return apprenticeSga;
      } else {
        const { data: jobseekerSga } = await Get(
          `${ApiPath.JobSeekerSurvey}/getjobseekersga`
        );
        commit("SET_SGA", jobseekerSga);
        return jobseekerSga;
      }
    },

    async postsga({ commit }, sga) {
      const isApprentice =
        this.state.account.current_user.roles.includes("Apprentice");
      if (isApprentice) {
        const { data: apprenticeSga } = await Post(
          `${ApiPath.ApprenticeSurvey}/postapprenticesga`,
          sga
        );
        commit("SET_SGA", apprenticeSga);
        return apprenticeSga;
      } else {
        const { data: jobseekerSga } = await Post(
          `${ApiPath.JobSeekerSurvey}/postjobseekersga`,
          sga
        );
        commit("SET_SGA", jobseekerSga);
        return jobseekerSga;
      }
    },

    async putsga({ commit }, sga) {
      const isApprentice =
        this.state.account.current_user.roles.includes("Apprentice");
      if (isApprentice) {
        const { data: apprenticeSga } = await Put(
          `${ApiPath.ApprenticeSurvey}/putapprenticesga`,
          sga
        );
        commit("SET_SGA", apprenticeSga);
        return apprenticeSga;
      } else {
        const { data: jobseekerSga } = await Put(
          `${ApiPath.JobSeekerSurvey}/putjobseekersga`,
          sga
        );
        commit("SET_SGA", jobseekerSga);
        return jobseekerSga;
      }
    },

    // store({ commit }, sga) {
    //   let userid =
    //     sessionStorage.getItem("UserId") == null
    //       ? null
    //       : sessionStorage.getItem("UserId");
    //   let api_url = null;
    //   if (this.state.apprentice.current_user) {
    //     api_url = `${process.env.VUE_APP_API_BASE_URI}apprentice/postsga?userid=${userid}`;
    //   } else {
    //     api_url = `${process.env.VUE_APP_API_BASE_URI}jobseeker/postsga?userid=${userid}`;
    //   }
    //   return axios
    //     .post(api_url, sga)
    //     .then(() => {
    //       commit("SET_SGA", sga);
    //       return sga;
    //     })
    //     .catch((res) => {
    //       throw res.response.data;
    //     });
    // },

    getWeightingMatches({ commit }, employee) {
      return (
        axios
          .post(
            `${process.env.VUE_APP_API_BASE_URI}sga/candidates?employeeId=${employee}`
          )
          // .then(() => employee)
          .catch((res) => {
            throw res.response.data;
          })
      );
    },
    vacant({ commit }, sga) {
      return axios
        .post(`${process.env.VUE_APP_API_BASE_URI}sga/createvacantrole`, sga)
        .then(() => {
          commit("SET_SGA", sga);
          return sga;
        })
        .catch((res) => {
          throw res.response.data;
        });
    },
    setdefaultmanager({}, linemanager) {
      let userid =
        sessionStorage.getItem("debugid") == null
          ? null
          : sessionStorage.getItem("debugid");
      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URI}sga/setdefaultmanager?employeelinemanager=${linemanager}&userid=${userid}`,
          linemanager.toString()
        )
        .then(() => {
          //
        })
        .catch((res) => {
          throw res.response.data;
        });
    },
    getcodedetail({}, codeheaderid) {
      return axios
        .get(
          `${process.env.VUE_APP_API_BASE_URI}sga/getcodedetail?codeheaderid=${codeheaderid}`
        )
        .then((res) => {
          return res.data;
        });
    },
    submitcertificate({}, newcertificate) {
      let userid =
        sessionStorage.getItem("debugid") == null
          ? null
          : sessionStorage.getItem("debugid");
      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URI}sga/submitcertificate?userid=${userid}`,
          newcertificate
        )
        .then((res) => {
          return res.data;
        })
        .catch((res) => {
          throw res.response.data;
        });
    },

    // this is where the list of activities, knowledge, skills, essential skills are fetched
    async getSGAforPrint({ commit }, hiddenExtras) {
      var defaultCode = "15-1132.00";
      var taskCode =
        this.state.sga.current_sga.sgaEmployeeInfo.employeeRoleONETCode;

      const { data: res } = await Get(
        `${ApiPath.Onet}/onetcollectionbycode?onetCode=${defaultCode}&taskCode=${taskCode}`
      );
      commit("SET_JOB_TASKS", res.jobTasks);
      const mappedActivities = res.workActivities.map((activity) => {
        const activitySelection = hiddenExtras.workingPracticeActivities.find(
          (c) => c.selection === activity
        );
        return {
          checked: activitySelection ? true : false,
          rating: activitySelection ? activitySelection.rating : null,
          activity,
          value: activitySelection ? activitySelection.value : null,
        };
      });
      commit("SET_WORK_ACTIVITIES", mappedActivities);
      commit("SET_ADDITIONAL_KNOWLEDGE", res.additionalKnowledge);
      commit(
        "SET_SOFT_STYLES",
        res.softSkills.map((v) => v.skill)
      );
      commit(
        "SET_WORK_SKILLS",
        res.workSkills.map((skill) => {
          return skill;
        })
      );
      commit("SET_HIDDEN_TALENTS", res.hiddenTalents);
      return res;
    },
    getCodeHeaderDetails({ commit }) {
      return axios
        .get(`${process.env.VUE_APP_API_BASE_URI}sga/getcodeheaderdetails`)
        .then((res) => {
          commit("SET_CERTIFICATES", res.data);
        })
        .catch((res) => {
          const errors = res.response;
          throw errors;
        });
    },
    getPublicProfile({}, userid) {
      return axios
        .get(
          `${process.env.VUE_APP_API_BASE_URI}identity/GetPublicProfile?userid=${userid}`
        )
        .then((res) => {
          return res;
        })
        .catch((res) => {
          const errors = res.response;
          throw errors;
        });
    },

    // getuserprofilepagesettings({ }, requestId) {
    //   const userid =
    //     sessionStorage.getItem("debugid") == null
    //       ? null
    //       : sessionStorage.getItem("debugid");
    //   return axios
    //     .get(
    //       `${process.env.VUE_APP_API_BASE_URI}identity/GetUserProfilePageSettings?userId=${userid}&requestId=${requestId}`
    //     )
    //     .then((res) => {
    //       return res;
    //     })
    //     .catch((res) => {
    //       const errors = res.response;
    //       throw errors;
    //     });
    // },

    // getprofiledetails({ }, obj) {
    //   return axios
    //     .get(
    //       `${process.env.VUE_APP_API_BASE_URI}identity/GetProfileDetails?userid=${obj.userid}&cvid=${obj.cvid}`
    //     )
    //     .then((res) => {
    //       return res;
    //     })
    //     .catch((res) => {
    //       const errors = res.response;
    //       throw errors;
    //     });
    // },
    async getPublicCodeHeaderDetails({ commit }) {
      const { data: certificates } = await Get(
        `${ApiPath.Organisation}/getallreferencesbyreferencetypecategory`,
        {
          referenceTypeCategory: "CERTIFICATE",
        }
      );

      commit("SET_CERTIFICATES", certificates);

      return certificates;
    },
  },
};
